import { BookingHospitalityGet, SubmitAccommodationRequest, UploadBlob } from "@graphql";
import { Navigation } from "@navigation";
import { store } from "@store";
import { AccommodationRequest } from "./AccommodationRequest";

export interface AccommodationRequestSubmitterOptions {
  bookingGroupId: string;
  matchBookings: Array<{ _id: string; Week: Date }>;
  accommodationRequestId: string;
  consultantId: string;
  consultantName: string;
  location: string;
  startDate: Date;
  tags: string[]; // = [];
  onCancel: () => void;
  formValues: Omit<AccommodationRequest, "weeks" | "repeat" | "weekDays">;
  nav: Navigation;
  setLoading: (v: boolean) => void;
}

export class AccommodationRequestSubmitter {
  constructor(public options: AccommodationRequestSubmitterOptions) {
    options.tags = options.tags || [];
  }

  submit() {
    this.options.setLoading(true);

    return this.step1SubmitForm()
      .then(() => {
        this.step2CleanUp();
      })
      .catch((err) => {
        store().snackbars.error(`Cannot save accommodation request\nReason: ${err}`);
      })
      .finally(() => {
        this.options.setLoading(false);
      });
  }

  private convertToBoolean(value: string | null) {
    return value === "true";
  }

  private async step1SubmitForm() {
    const { bookingConfirmationFile, hasCarAccess, hasOwnCar, ...restValues
    } = this.options.formValues;

    const bookingIds = this.options.matchBookings?.map((x) => x._id) ?? [];

    const formValues = {
      ...restValues,
      hasCarAccess: this.convertToBoolean(hasCarAccess),
      hasOwnCar: this.convertToBoolean(hasOwnCar),

      // @deprecated: Remove these fields when we have removed the old form
      carAccess: null,
      sharedConveniences: null
    };

    let file;

    if (bookingConfirmationFile?.file) {
      const blobRes = await UploadBlob.func({ file: bookingConfirmationFile.file });
      file = blobRes.data.uploadBlob;
    }

    return SubmitAccommodationRequest.func(
      {
        bookingGroupId: this.options.bookingGroupId,
        bookingIds,
        input: formValues,
        file
      },
      {
        refetchQueries: [BookingHospitalityGet.OperationName]
      }
    );
  }

  private step2CleanUp() {
    this.options.nav.unBlock("hospitality_request");
    store().snackbars.success("Accommodation request sent");
    this.options.nav.close();
  }
}
